module.exports = __webpack_public_path__ + "static/media/yellowhead-20.42333d06.jpg";